import { styled, css, Card, CardProps } from '@mui/material'
import { AppFooterStylesProps } from './AppFooter.types'

export const AppFooterWrapper = styled(Card, {
  name: 'AppFooter'
})<CardProps & AppFooterStylesProps>(
  ({ theme, radius }) => css`
    z-index: ${theme.zIndex.appBar};
    position: relative;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    border-radius: ${typeof radius === 'number'
      ? `${radius}px ${radius}px 0 0`
      : radius};
    color: ${theme.palette?.text?.primary};
    background-color: ${theme.palette?.background?.paper};
    background-image: none;

    &:empty {
      display: none;
    }
  `
)
AppFooterWrapper.defaultProps = {
  color: 'default',
  elevation: 4,
  radius: 0
}

export default AppFooterWrapper
